import { render, staticRenderFns } from "./bigelow.vue?vue&type=template&id=2dd839a4&scoped=true&"
import script from "./bigelow.vue?vue&type=script&lang=js&"
export * from "./bigelow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd839a4",
  null
  
)

export default component.exports